import React from 'react'
import { RoomModel } from '../../common/models/RoomModel.js'
import { BaseCalendar } from './BaseCalendar.js'

export interface RoomCalendarProps {
    room: RoomModel
}

export function RoomCalendar({ room }: RoomCalendarProps) {
    return (
        <BaseCalendar
            rooms={[room]}
            singleRoom={true}
            className="mt-4"
            maxHeight="400px"
        />
    )
}
